import React, { useEffect, useState } from 'react'
import { BsFillPersonFill } from 'react-icons/bs'
import { AiOutlineForm, AiOutlineLogout } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'
import './sidebar.css'
import logo1 from '../../StudentRegristrationDesign/jain logo.png'
import { Modal } from 'antd'

function Sidebar() {
  const [isOpen, setIsOpen] = useState(true)

  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate()

  let userdata = sessionStorage.getItem('userdata')

   // Show modal when user clicks logout
  const showLogoutModal = () => {
    setIsModalVisible(true);
  };

  // Confirm logout
  const handleLogout = () => {
    sessionStorage.removeItem('userdata');
    sessionStorage.clear();
    setIsModalVisible(false);
    navigate('/');
  };

  // Cancel logout
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (userdata == null) {
      sessionStorage.clear();
      navigate('/');
    }
  }, []);

  return (
    <div
      className={`sidebar ${isOpen ? 'open' : ''}`}
     style={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1',        
        height: '100vh',
        background: '#a2d6f8',
        color: '#000',
        fontFamily: 'Poppins, sans-serif',
        transition: 'all 0.3s ease',
      }}
    >
      <div className="row logo-details text-center mb-5">
        <div
          className="logo_name"
          style={{
            color: '#0783d6ff',
            fontSize: '22px',
            fontWeight: 600,
            letterSpacing: '1px',
            margin: '0 auto',
          }}
        >
          <img
            src={logo1}
            alt="Logo"
            style={{ mixBlendMode: 'darken',height:"100px" }}
          />
        </div>

      </div>

      <div className="sidebar-content px-2">
        <ul className="nav-list mb-5">
          <li>
            <a style={{backgroundColor:"white"}} href="/#/AluminiDashboard" className="active ">
              <i className="fa fa-line-chart"></i>
              <span className="links_name">Dashboard</span>
            </a>
          </li>
          <li>
            <a style={{backgroundColor:"white"}} href="/#/Jobpost">
              <i class="fa-solid fa-folder-plus"></i>
              <span className="links_name">Job Post</span>
            </a>
          </li>
          <li>
            <a style={{backgroundColor:"white"}} href="/#/AluminiAllJob">
              <i className="fa-solid fa-list"></i>
              <span className="links_name">Jobs</span>
            </a>
          </li>

          <li>
            <a style={{backgroundColor:"white"}} href="/#/GalleryAlumini">
              <i class="fa-solid fa-image"></i>
              <span className="links_name">Gallery</span>
            </a>
          </li>

          <li>
            <a style={{backgroundColor:"white"}} href="/#/Suggestion">
              <i class="fa-solid fa-file-circle-plus"></i>
              <span className="links_name">Suggestion Form</span>
            </a>
          </li>

          <li>
            <a onClick={showLogoutModal} style={{cursor:"pointer",backgroundColor:"white"}}>
              <i class="fa-solid fa-circle-arrow-left"></i>
              <span className="links_name">Log Out</span>
            </a>
          </li>
        </ul>

        <Modal
          title="Confirm Logout"
          visible={isModalVisible}
          onOk={handleLogout}
          onCancel={handleCancel}
          okText="OK"
          cancelText="Cancel"
        >
          <p>Are you sure you want to log out?</p>
        </Modal>
   

      </div>
    </div>
  )
}

export default Sidebar
